export const selfSignUpUserData =  {
        tenant_type: "Organization Type",
        tenant_name: "Organization Name",
        tenant_industryType: "Industry Type",
        tenant_RegDocuments: "Select Document",     //
        tenant_RegDocuments_type: "Select Document Type",  //
        tenant_address1:"Address 1" ,
        tenant_address2:"Address 2" ,
        tenant_city: "City",
        tenant_state: "State",
        tenant_postCode: "Post Code" ,
        tenant_country:"Country" ,
    contact:{
      tenant_title: 'Title',
      tenant_firstName: 'First Name',
      tenant_lastName: 'Last Name',
      tenant_designation: 'Designation',
      tenant_email: 'Email',
      tenant_phone: 'Phone Number',
      admin_user: "Admin User",
      tenant_AdminLoginId: 'Admin Login Id',
      tenant_AdminLoginPassword: 'Admin Login Password',
      tenant_language: 'Language',
        } ,


        tenant_systemCapabilities: "System Capabilities ",
        tenant_wmsSystemInUse:"WMS System In Use" ,
        tenant_erpSystemInUse: "ERP System In Use",
        tenant_integrationRequired: "Integration required",
        tenant_numberOfUserLicenses:"Number of User Licenses"  ,
        tenant_subscriptionModel:"Subscription Plan" ,
        tenant_paymentDetails: "Payment Details" ,
      };